import { Ticket } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TicketIcon = createLucideIcon(Ticket);
